export enum SensorStatusEnum {
    Offline = 0,
    Online = 1,
    Warning = 2,
    Critical = 3
}
